
import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { NavigationGuard } from './core/auth/guards/navigation.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'apps/home'},

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'apps/home'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'api/auth/reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            {path:'api/auth/email/verify',loadChildren:()=>import('app/modules/auth/email-verify/email-verify.module').then(m=>m.EmailVerifyModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },

    // Landing routes
    {
        path: '',
        component  : LayoutComponent,
        data: {
            layout: 'empty'
        },
        children   : [
            //{path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
        ]
    },





    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard,NavigationGuard],
   // canActivateChild: [AuthGuard,NavigationGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [

            // Apps
            {path: 'apps',

                children: [
                {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
                {path: 'users-management', loadChildren: () => import('app/modules/admin/user-management/user-management.module').then(m => m.UserManagementModule)},
                {path: 'recordings', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)},
                {
                    path: 'category',
                    loadChildren: () => import('app/modules/category/category.module').then(m => m.CategoryModule),
                    canActivate:[NavigationGuard]
                },
                {
                    path:'plan',
                    loadChildren: ()=>import('app/modules/admin/plan-carrera/plan-carrera.module') .then(m => m.PlanCarreraModule),
                },
                {path: 'configuration',loadChildren: () => import('app/modules/admin/settings/settings.module').then(m => m.SettingsModule)},
                {path: 'overview',loadChildren:()=>import('app/modules/students/students.module') .then(m=>m.StudentsModule),},
                //{path: 'trainer',loadChildren:()=>import('app/modules/trainer/trainer.module') .then(m=>m.TrainerModule),}
                {
                    path: 'training',
                    loadChildren: () => import('app/modules/admin/reports/compliance/compliance.module').then( m => m.ComplianceModule),
                },
                 {

                    path: 'compliance/v1',
                    loadChildren: () => import('app/modules/admin/reports/v1/compliance/compliance.module').then( m => m.ComplianceModule),
                },
                {
                    path:'training/v1',
                    loadChildren: ()=> import('app/modules/admin/reports/v1/training-curve/training-curve.module') .then(m=>m.TrainingCurveModule),
                }

            ]},

            {path: 'user-profile', loadChildren: () => import('app/layout/common/user/user-profile/user-profile.module').then(m => m.UserProfileModule)},
            {
                path: 'certificates',
                loadChildren: () => import('./layout/common/user/user-certificate/user-certificate.module').then( m => m.UserCertificateModule)
            }
        ]
    }
];
